/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.publicBusinessSettings

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.publicBusinessSettings.PublicBusinessSettingsApi
import features.publicBusinessSettings.models.PublicBusinessSettings
import features.publicBusinessSettings.serializePublicBusinessSettingsState



/**
 * Get the public settings of a business. [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("PublicBusinessSettingsApi")
class PublicBusinessSettingsApiJs {

    /**
     * Get the public settings of a business.
     */
    fun getPublicBusinessSettings(
        overrideHeaders: String?, 

    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = PublicBusinessSettingsApi().getPublicBusinessSettings(
            overrideHeaders = decodedOverrideHeaders,
            
        ).toJsonResult<PublicBusinessSettings>()
        
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observePublicBusinessSettingsState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        PublicBusinessSettingsApi().publicBusinessSettingsState.serializePublicBusinessSettingsState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
